import { ReceiptSelectItemModel, SEARCH_TYPE } from '@common/interfaces';
import { GetDocumentListTktResponse } from 'src/sdk-servicing';
import { ReceiptSelectItemModelImpl } from './receipt-select-item-model-impl';
import { ReceiptSelectItemFlightSegmentImpl } from './receipt-select-item-flight-segment-impl';
import { StaticMsgPipe } from '@lib/pipes';
import { Injectable } from '@angular/core';
import { ReceiptSelectService } from './receipt-select.service';

/**
 *  航空券リスト取得API応答ハンドラ。
 */
@Injectable()
export class ETicketHandler {
  constructor(private _receiptSelectService: ReceiptSelectService, private _staticMsg: StaticMsgPipe) {}

  /**
   * レスポンス内容を航空券一覧表示内容リストに変換する。
   *
   * @param response 航空券リスト取得APIのレスポンス。
   * @param searchType 検索種別。
   * @returns レスポンス内容から置き換えられた航空券一覧表示内容リスト。
   */
  toEticketList(response: GetDocumentListTktResponse, searchType: SEARCH_TYPE): ReceiptSelectItemModel[] {
    const itemTitle = this._staticMsg.transform('label.eTicket');
    return response.data.eTicketList.map((e) => {
      const item = new ReceiptSelectItemModelImpl(itemTitle, false);
      item.flightList = [
        new ReceiptSelectItemFlightSegmentImpl(
          e.sectionList.map((section) => ({ ...section })),
          [
            {
              ticketOrEmdNumber: e.eTicketNumber,
              issuedDate: e.issuedDate,
              travelerName: e.travelerName,
              isDisplayAvailable: e.isDisplayAvailable,
              travelerId: e.travelerId,
              receivedFrom: this._receiptSelectService.getDefaultReceivedFrom(e.travelerName, searchType),
            },
          ],
          false
        ),
      ];
      return item;
    });
  }
}
